import { render, staticRenderFns } from "./calibrations.vue?vue&type=template&id=084168a4&scoped=true&"
import script from "./calibrations.vue?vue&type=script&lang=js&"
export * from "./calibrations.vue?vue&type=script&lang=js&"
import style0 from "./calibrations.vue?vue&type=style&index=0&id=084168a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084168a4",
  null
  
)

export default component.exports